import React from 'react';
import ServePositionManager from '../components/ServePositions/ServePositionManager';

const ServePositions = () => {
  return <ServePositionManager />;
};

export default ServePositions;
